import type { IAmbassadorDetailData } from '~/@api/generated-api-types-ambassador/Api'
import { InfoField } from '~/@mid_ui/info-field/InfoField'
import { CurrencyFormatter } from '~/@mid_ui/currency-formatter/CurrencyFormatter'
import { DateTimeFormatter } from '~/@mid_ui/datetime-formatter/DateTimeFormatter'
import { StatCard } from '~/@mid_ui/stat-card/StatCard'

type Props = {
  detail: IAmbassadorDetailData
}

export function DetailSummary({ detail }: Props) {
  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-2 gap-y-4 md:grid-cols-4 p-5 bg-foreground">
        <InfoField
          label="Referencia"
          value={detail.reference}
          valueClassName="underline"
        />
        <InfoField
          label="Vytvorené"
          value={<DateTimeFormatter value={detail.createdAt} />}
        />
        <InfoField label="Kód" value={detail.code} valueClassName="underline" />
        <InfoField
          label="Stav"
          value={detail.isEnabled ? 'Aktívny' : 'Neaktívny'}
          valueClassName={detail.isEnabled ? 'text-green-light' : 'text-muted'}
        />
      </div>

      <div className="grid grid-cols-2 border border-foreground divide-x div">
        <StatCard label="Získaný klienti" value={detail.sums.clientCount} />
        <StatCard
          label="Investované klientami"
          value={
            <CurrencyFormatter
              className="text-xl md:text-[32px] font-semibold"
              decimalClassName="text-base md:text-xl font-semibold"
              value={detail.sums.investedSum}
            />
          }
        />
      </div>
    </div>
  )
}
